const questions =[{
    id: 1,
    title: 'How long until we deliver your first blog post?',
    info: 'Really boy law county she unable her sister. Feet you off its like like six. Among six are leave law built now. In built table in an rapid blush. Merits behind on afraid or warmly.'
},
{
    id: 2,
    title: 'How long until we deliver your first blog post?',
    info: 'Really boy law county she unable her sister. Feet you off its like like six. Among six are leave law built now. In built table in an rapid blush. Merits behind on afraid or warmly.'
},
{
    id: 3,
    title: 'How long until we deliver your first blog post?',
    info: 'Really boy law county she unable her sister. Feet you off its like like six. Among six are leave law built now. In built table in an rapid blush. Merits behind on afraid or warmly.'
},
{
    id: 4,
    title: 'How long until we deliver your first blog post?',
    info: 'Really boy law county she unable her sister. Feet you off its like like six. Among six are leave law built now. In built table in an rapid blush. Merits behind on afraid or warmly.'
}

,
{
    id: 5,
    title: 'How long until we deliver your first blog post?',
    info: 'Really boy law county she unable her sister. Feet you off its like like six. Among six are leave law built now. In built table in an rapid blush. Merits behind on afraid or warmly.'
}

,
{
    id: 6,
    title: 'How long until we deliver your first blog post?',
    info: 'Really boy law county she unable her sister. Feet you off its like like six. Among six are leave law built now. In built table in an rapid blush. Merits behind on afraid or warmly.'
}
]

export default questions;